import React, { PropsWithChildren } from "react";
//#region types
import { FilePreviewLayoutProps } from "models/propTypes/pageLayoutPropTypes";
import { HTMLConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const EntityPreviewLayout: React.FC<PropsWithChildren<FilePreviewLayoutProps>> = (props) => {
  return (
    <Grid container className={clsx(cssExports.entityCreationLayout, props.className)}>
      <Grid container direction="column">
        <Grid item container spacing={4} className={cssExports.upperContainer}>
          <Grid item container md={7}>
            {props.upperLeftComponent}
          </Grid>
          <Grid item container md={5} direction="column" justifyContent="flex-end"></Grid>
        </Grid>
        <Grid item container spacing={4}>
          <Grid
            id={HTMLConstants.EntityPreviewLayoutLowerLeftPortalId}
            item
            container
            md={7}
            className={cssExports.lowerLeftContainer}
          >
            {props.lowerLeftComponent}
          </Grid>
          <Grid
            item
            container
            md={5}
            direction="column"
            className={cssExports.viewPanelItemContainer}
            justifyContent="space-between"
          >
            {props.children}
          </Grid>
        </Grid>
      </Grid>
      {props.footer}
    </Grid>
  );
};

export default EntityPreviewLayout;
